// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"index-module--checkbox--2L0Tq"};